var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonwealthOfIndependentStates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0073cf",
    d: "M0 24h30V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.73 18.4v-5.7a11 11 0 0 1-3.55-1.83.47.47 0 1 1 .64-.67 8 8 0 0 0 3.47 2.34v5.85zm.75 0v-5.98a8 8 0 0 1-3.94-2.86.56.56 0 1 1 .96-.55 6 6 0 0 0 3.54 3.3v6.09zm.75 0v-6.23a5.8 5.8 0 0 1-3.9-4.35.8.8 0 1 1 1.58-.08 4.1 4.1 0 0 0 2.88 4.34v6.32zm.74 0v-6.46a3.92 3.92 0 0 1-1.6-6.7.93.93 0 1 1 1.13 1.48 2.8 2.8 0 0 0 1.03 5.13v6.55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.27 18.4v-5.7a11 11 0 0 0 3.55-1.83.47.47 0 1 0-.64-.67 8 8 0 0 1-3.47 2.34v5.85zm-.75 0v-5.98a8 8 0 0 0 3.94-2.86.56.56 0 1 0-.96-.55 6 6 0 0 1-3.54 3.3v6.09zm-.75 0v-6.23a5.8 5.8 0 0 0 3.9-4.35.8.8 0 1 0-1.58-.08 4.1 4.1 0 0 1-2.88 4.34v6.32zm-.74 0v-6.46a3.92 3.92 0 0 0 1.6-6.7.93.93 0 1 0-1.13 1.48 2.8 2.8 0 0 1-1.03 5.13v6.55z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.72 11.88q.28.01.56 0v6.52h-.56z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fecb00",
    d: "M15 10.21a1.12 1.12 0 1 0 0-2.24 1.12 1.12 0 0 0 0 2.24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonwealthOfIndependentStates);
export default __webpack_public_path__ + "static/media/commonwealth-of-independent-states.2643ea901551011e99bdd22fd0f4b297.svg";
export { ForwardRef as ReactComponent };